const { checkElement } = require('./helperFunctions');

const adjustPDFButtons = () => {
    const pdfButtons = document.querySelector('.fullscreen-controls.underneath');
    const arrow1 = `<svg xmlns="http://www.w3.org/2000/svg" width="25.27" height="25.27" viewBox="0 0 25.27 25.27">
  <g id="Group_884" data-name="Group 884" transform="translate(14.736) rotate(45)">
    <path id="Path_92" data-name="Path 92" d="M1.558,7.346,6.892,1.77V20.84H8V1.77l5.334,5.576L14.9,7.331,7.85,0h-.8L0,7.331Z" transform="translate(14.897 20.84) rotate(180)" fill="#7e71ff"/>
    <path id="Path_993" data-name="Path 993" d="M1.558,7.346,6.892,1.77V20.84H8V1.77l5.334,5.576L14.9,7.331,7.85,0h-.8L0,7.331Z" transform="translate(0 0)" fill="#7e71ff"/>
  </g>
</svg>
`;
    const arrow2 = `<svg xmlns="http://www.w3.org/2000/svg" width="14.897" height="20.84" viewBox="0 0 14.897 20.84">
<path id="Path_92" data-name="Path 92" d="M1.558,7.346,6.892,1.77V20.84H8V1.77l5.334,5.576L14.9,7.331,7.85,0h-.8L0,7.331Z" transform="translate(14.897 20.84) rotate(180)" fill="#7e71ff"/>
</svg>
`;
    if (pdfButtons) {
        const downloadButton = pdfButtons.querySelector('.download-pdf');
        const expandButton = pdfButtons.querySelector('.fullscreen-open');

        if (downloadButton && expandButton) {
            downloadButton.innerHTML = '';
            expandButton.innerHTML = '';

            downloadButton.insertAdjacentHTML('beforeend', `<p>Download Asset</p>`);
            downloadButton.insertAdjacentHTML('beforeend', arrow2);

            expandButton.insertAdjacentHTML('beforeend', `<p>Expand Fullscreen</p>`);
            expandButton.insertAdjacentHTML('beforeend', arrow1);

            //create new container
            const newContainer = document.createElement('div');
            newContainer.classList.add('new-content-container');

            const entryWrapper = document.querySelector('.entry-wrapper');
            const levelThree = document.querySelector('.level-three');

            if (entryWrapper && levelThree) {
                newContainer.insertAdjacentElement('beforeend', pdfButtons);
                newContainer.insertAdjacentElement('beforeend', entryWrapper);

                levelThree.insertAdjacentElement('beforeend', newContainer);
            }
        }
    }
};


// on load
function handleFlipbookButton() {
    // wait for blocking-cta to be in the DOM, (delayed from the platform + if the gate has a delayed gate)
    checkElement('.blocking-cta').then(() => {
        const gatedCTA = document.querySelector('.block-cta');
        const fullScreenControls = document.querySelector('.fullscreen-controls.underneath');
        const itemPage = document.querySelector('.single-page');

        if (gatedCTA && fullScreenControls && itemPage) {
            itemPage.classList.add('active-gatedCTA');

        }
    });
}

// on ctaFormSubmitSuccess
function handleGatedCTASubmit() {
    const singlePage = document.querySelector('body.single-page');
    if (singlePage && singlePage.classList.contains('active-gatedCTA')) {
        singlePage.classList.remove('active-gatedCTA');

    }
}

module.exports = { adjustPDFButtons, handleFlipbookButton, handleGatedCTASubmit };


// WEBPACK FOOTER //
// ./scriptPartials/adjustPDFButtons.js